<template>
  <div>
    <div v-if="$root.$i18n.locale === 'en'" class="error">
      <h3>Translation Missing</h3>
      <p>We apologize that this page has not been translated yet.</p>
    </div>
    <article>
      <header>
        <h2>Hallo Du!</h2>
      </header>
      <main>
        <p>
          Ich weiß, du hast viele Fragen über die ABDL frɘchdax Party.
          Die meisten davon sollte ich dir sofort beantworten können.
          Falls ich etwas vergessen haben sollte, dann
          <router-link :to="{name: 'contact'}">schicke mir einfach direkt deine Frage</router-link>
          .
        </p>
        <p>
          <strong>Klicke einfach auf eine Frage, um nähere Informationen aufzudecken.</strong>
        </p>
      </main>
    </article>

    <div style="margin-top: 40px">
      <h2 style="color: white">Allgemeines</h2>
      <expander>
        <template slot="title">ABDL</template>
        <template slot="icon">help_outline</template>
        <template slot="subtitle">Was bedeutet ABDL?</template>
        <template slot="content">
          <p>
            Die Abkürzung ABDL steht für die Fetisch-Richtung "Adult Baby / Diaper Lover".
          </p>
          <p>
            Als Adult Babies bezeichnen sich Leute, die Gefallen daran finden, als Baby oder als kleines Kind behandelt
            zu werden und sich als solches verhalten zu dürfen.
            Dazu gehört auch meistens das Tragen und Benutzen von Stramplern, Bodys, Schnullern und Fläschchen.
            Ähnlich wie bei den Slaves/Subs oder auch beim Petplay geht es meist darum, die Kontrolle an jemand anderem
            abzugeben. Viele wollen aber auch einfach nur mal wieder die Unbeschwertheit eines Kindes genießen und
            empfinden dabei garkeine sexuelle Erregung.
          </p>
          <p>
            Als Diaper Lovers bezeichnen sich Leute, die Gefallen daran finden, Windeln zu tragen und zu
            benutzen. Dies lässt sich am ehesten mit anderen Kleidungs-Fetischen wie Rubber, Leder,
            Sportwäsche oder Uniformen vergleichen.
          </p>
          <p>
            Meistens ist eine Mischung aus Adult Baby und Diaper Lover anzutreffen, da sich beide Fetische natürlich
            ideal ergänzen.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Meine erste Fetischparty</template>
        <template slot="icon">help_outline</template>
        <template slot="subtitle">Soll ich da hingehen? Ich war noch nie auf so einer Party.</template>
        <template slot="content">Bestimmt hast du viele Vorurteile, Scheu oder Hemmungen, wenn du noch nie auf einer
          ABDL
          oder einer anderen Fetisch-Party warst. Da kann ich dich aber beruhigen. Die Party ist wesentlich
          harmloser, als viele sich das vorstellen. Es sind ganz normale Menschen dort, die sich unterhalten,
          lachen, gemeinsam etwas trinken und sich hin und wieder wickeln. Man kommt relativ leicht mit
          anderen Leuten ins Gespräch, da alle ein gemeinsames Interesse an dem ABDL Thema haben.
          Du kannst frei entscheiden, was du alles ausprobieren möchtest. Schau es dir am Anfang einfach
          an und unterhalte dich mit den Leuten. Und wenn du mehr ausprobieren möchtest, dann steht dem
          nichts im Wege ;-)

        </template>
      </expander>
      <expander>
        <template slot="title">Rahmen&shy;programm</template>
        <template slot="icon">event_note</template>
        <template slot="subtitle">Gibt es neben der Party weitere Programmpunkte?</template>
        <template slot="content">Das aktuelle Tagesprogramm findest du auf
          <router-link :to="{name: 'save-the-date'}">Save the Date</router-link>.
        </template>
      </expander>
      <expander>
        <template slot="title">Checkliste Gepäck</template>
        <template slot="icon">baggage</template>
        <template slot="subtitle">Was sollte ich alles mitnehmen?</template>
        <template slot="content">Neben deinem ABDL Outfit (siehe Dresscode weiter unten), solltest du ein paar frische
          Windeln mitbringen, falls du vor hast, sie zu benutzen. Puder und Creme halten außerdem den
          Popo geschmeidig ;-) Bitte ziehe auf jeden Fall festes Schuhwerk an und bringe deinen
          Personalausweis oder Reisepass (keinen Führerschein!) mit. Sonst brauchst du eigtl. nichts
          beachten. Deine Jacke und Straßenkleidung kannst du in deinen Spind sperren.
        </template>
      </expander>
      <h2 style="color: white">Veranstalter</h2>
      <expander>
        <template slot="title">Team Frechdax</template>
        <template slot="subtitle">Wer steckt hinter der frɘchdax Party?</template>
        <template slot="content">
          Da ABDL Parties in Süddeutschland leider nicht häufig zu finden sind, hat sich eine Gruppe von
          befreundeten Münchner ABDLs unter dem Namen "Frechdax" zusammengetan,
          um in Kooperation mit dem MLC eine solche Party zu etablieren.
          So müssen wir selbst nicht immer so weit fahren zu den Parties.
        </template>
      </expander>
      <expander>
        <template slot="title">Münchner Löwen Club (MLC)</template>
        <template slot="subtitle">Was ist der MLC?</template>
        <template slot="content">
          Der Münchner Löwen Club ist einer der größten Europäischen schwulen Fetischvereine.
          Wir veranstalten unsere Frechdax ABDL Party in deren Vereinslocation, dem Underground, in München.
          Der MLC München e.V. ist der offizielle Veranstalter. Es gelten die Bedingungen und das Hausrecht des Vereins
        </template>
      </expander>
      <h2 style="color: white">Räumlichkeiten</h2>
      <expander>
        <template slot="title">Kapazität</template>
        <template slot="icon">people</template>
        <template slot="subtitle">Wie viele Leute kommen zur Party?</template>
        <template slot="content">
          Die Location bietet Platz für um die 200 Gäste. Mehr dürfen wir leider nicht hereinlassen.
          Wir würden uns freuen, wenn ihr uns ein wenig helft Werbung zu machen, da unsere Party noch recht jung ist.
        </template>
      </expander>
      <expander>
        <template slot="title">Garderobe</template>
        <template slot="icon">lock_outline</template>
        <template slot="subtitle">Gibt es Spinde und Umkleidemöglichkeiten?</template>
        <template slot="content">
          <p>
            Es gibt eine große Gemeinschaftsumkleide mit persönlichem Spind und persönlichem Schlüssel
            für jeden Gast. Du musst dir also keine Sorge machen, dass du keinen Platz für deine Klamotten
            findest. Bitte beachtet aber, dass keine Haftung für die Garderobe übernommen wird.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Getränke und Essen</template>
        <template slot="icon">restaurant</template>
        <template slot="subtitle">Was gibt es für das leibliche Wohl?</template>
        <template slot="content">
          <p>
            Es gibt eine Bar mit großer Getränkeauswahl und ein paar Knabbersachen. Am besten schmaust
          ihr vor der Party schon, denn von Salzstangen wird man nicht satt. Selbst mitgebrachte Speisen oder Getränke
          sind nicht gestattet.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">WC und Duschen</template>
        <template slot="icon">wc</template>
        <template slot="subtitle">Gibt es Toiletten und Duschen?</template>
        <template slot="content">
          <p>Selbstverständlich. Die Toiletten könnt und sollt ihr auch für das große Geschäft verwenden. Für das kleine
            Geschäft seit ihr ja hoffentlich gut verpackt ;-)</p>
          <p>Duschen und Handtücher gibt es ebenso. Den Hair Conditioner müsst ihr aber selber
            mitbringen ;-)
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Wickel&shy;bereiche</template>
        <template slot="subtitle">Gibt es Wickelecken?</template>
        <template slot="content">
          <p>
            Wir haben einige extra Bereiche, die etwas abgetrennt sind, an denen ihr euch frisch wickeln oder
          wickeln lassen könnt. Es stehen auch Müllsäcke und Hygienematerial zur Verfügung
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Ausstattung</template>
        <template slot="icon">sports_esports</template>
        <template slot="subtitle">Welche Beschäftigungsmöglichkeiten gibt es während der Party?</template>
        <template slot="content">
          <p>
            Wir sorgen dafür, dass euch nicht langweilig wird. Es wird eine DVD Ecke mit
          Kinderfilmen, ein
          Bällebad, Käfige, Andreaskreuz, Stille Kiste und Fesselmöglichkeiten, sowie Spielzeuge und
          Wickelecken geben. Ausreichend Sitzgelegenheiten gibt es natürlich auch.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Barriere&shy;freiheit</template>
        <template slot="icon">accessible</template>
        <template slot="subtitle">Ist die Location barrierefrei?</template>
        <template slot="content">
          Nein die Locations der Dance&Diaper, sowie Play&Pamper sind leider nicht barrierefrei.
        </template>
      </expander>
      <expander>
        <template slot="title">Übernachtung</template>
        <template slot="icon">local_hotel</template>
        <template slot="subtitle">Gibt es Schlafmöglichkeiten bei euch?</template>
        <template slot="content">In der Location können wir leider keine Schlafmöglichkeiten anbieten. Allerdings sind
          in
          Fußreichweite ein paar Hotels zu finden. Schau doch einfach mal unter
          <router-link :to="{name: 'directions'}">Anfahrt</router-link>
          in die Karte.
        </template>
      </expander>
      <h2 style="color: white">Verhaltens&shy;regeln</h2>
      <expander>
        <template slot="title">Rauchverbot</template>
        <template slot="icon">smoke_free</template>
        <template slot="subtitle">Darf man auf der Party rauchen?</template>
        <template slot="content">
          In den Bereichen der Location besteht während der Veranstaltung Rauchverbot. Wir haben aber
          einen abgetrennten Container als Raucherbereich.
        </template>
      </expander>
      <expander>
        <template slot="title">Kaviar (KV)</template>
        <template slot="icon">highlight_off</template>
        <template slot="subtitle">Darf ich die Windel für KV verwenden?</template>
        <template slot="content">
          Wir wissen, dass es für viele von euch einfach dazugehört, den Stinker in die Windel zu machen.
          Aber es gibt auch viele, die das nicht mögen. Da bei der Party sehr viele Leute auf engem Raum
          sind, bitten wir euch aus Rücksicht anderen gegenüber auf das große Geschäft zu verzichten.
          Hierfür haben wir Toiletten. Pinkeln dürft ihr natürlich gerne in eure Windeln.
        </template>
      </expander>
      <expander>
        <template slot="title">Sex</template>
        <template slot="subtitle">Haben Gäste Sex während der Party?</template>
        <template slot="content">
          <p>
            Bei unserer Party sollen sich alle, sowohl ABs (Littles und nicht sexuell Geprägte), als auch DLs (Nutzen der Windel als sexueller Fetisch) und auch alle dazwischen wohlfühlen und sich ausleben können. Daher ist es uns wichtig, dass es Bereiche gibt, die sexfrei bleiben (z.B. Barbereich, Kinoecke und Spielzimmer), aber auch, dass es explizite, etwas privatere Bereiche gibt, in denen man sich sexuell austoben darf (z.B. Sling oder Darkroom-Labyrinth). Zudem appellieren wir an deine Fähigkeit, die Bedürfnisse der anderen wahrzunehmen und was das Thema angeht entsprechend sensibel zu handeln.
          </p>
          <p>
            Beachtet bitte außerdem: Generell gibt es natürlich eine Windelpflicht, insbesondere in den allgemeinen Bereichen, in den Gängen, etc.<br>
            Die Windelpflicht wird bei Bedarf auch von uns durchgesetzt, genau damit sich auch wirklich jeder wohlfühlen kann.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Drogen&shy;konsum</template>
        <template slot="icon">highlight_off</template>
        <template slot="subtitle">Wie hoch ist eure Toleranz im Bezug auf Drogen?</template>
        <template slot="content">Sollten wir dich mit Drogen erwischen, ist für dich die Party leider beendet.
        </template>
      </expander>
      <h2 style="color: white">Teilnahme&shy;beschränkungen</h2>
      <expander>
        <template slot="title">Alters&shy;begrenzung</template>
        <template slot="subtitle">Was ist das Mindestalter?</template>
        <template slot="content">
          Du musst mindestens 18 Jahre alt sein, um dabei sein zu dürfen. Falls du noch jünger sein solltest,
          dann musst du dich etwas gedulden. Das wird sicher nicht die letzte Party sein 😉. Nach oben hin
          gibt es keine Beschränkung.
        </template>
      </expander>
      <expander>
        <template slot="title">Men Only</template>
        <template slot="subtitle">Ist die Veranstaltung 'Men Only'?</template>
        <template slot="content">
          <p>
            Ja. Die Hauptveranstaltung ist bedingt durch die Location ausschließlich für Männer oder Transmänner mit ausgeprägt-männlichem Erscheinungsbild.
          </p>
          <p>
            Für die Sonderveranstaltungen ist jeder willkommen.
          </p>
        </template>
      </expander>
      <expander exp="dresscode">
        <template slot="title">Dresscode</template>
        <template slot="subtitle">Welche Kleidung sollte ich tragen?</template>
        <template slot="content">
          <p>
            Das wichtigste ist, dass ihr festes Schuhwerk anhabt und als ABDL kommt.
          Werft doch mal einen Blick auf den Dresscode:
            <img src="../assets/Dresscode_frechdax_v3.svg" width="100%" style="margin-top: 20px; border-radius: 8px;">
          </p>
          <p>
            Für die Sonderveranstaltungen gilt jeweils: Jeder ist willkommen. Ein strikter Dresscode ist nicht vorgegeben. Über den einen oder anderen Windelpopo freuen wir uns aber natürlich trotzdem.
          </p>
          <p>
            Achtet ansonsten auf angemessene Kleidung und die Vermeidung von Lärm außerhalb der Locations.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Ausweis&shy;kontrolle</template>
        <template slot="subtitle">Wie funktioniert das mit der Ausweiskontrolle und dem Ticket</template>
        <template slot="content">
          Ohne Personalausweis oder Reisepass können wir euch leider keinen Zutritt ins UnderGround oder Milla gewähren.
          An der Einlasskontrolle wird dein gültiges Ausweisdokument unter anderem für die Altersbestätigung kontrolliert.
          Durch die Übertragbarkeit der Tickets ist es egal, ob der Name deines Ausweises mit dem aufgedrucktem Namen auf deinem Ticket übereinstimmt.
        </template>
      </expander>
      <expander>
        <template slot="title">Ticket&shy;übertragung</template>
        <template slot="subtitle">Kann ich mein Ticket weiterverkaufen/übertragen?</template>
        <template slot="content">
          <p>
            Deine Tickets sind weiterverkaufbar/übertragbar. Stornieren kannst du Tickets allerdings leider nicht.
          </p>
          <p>
            Nach dem Eintritt verfällt die Gültigkeit des jeweiligen Tickets.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Einlass und Partyende</template>
        <template slot="subtitle">Wie lang geht die Party?</template>
        <template slot="content">
          <p>
            Der Einlass im UnderGround startet ab 20:00 Uhr und geht bis 23:00 Uhr.
            Um 5:00 Uhr früh muss der letzte Gast die Party verlassen haben.
          </p>
        </template>
      </expander>
      <expander>
        <template slot="title">Karten&shy;zahlung</template>
        <template slot="icon">lock_outline</template>
        <template slot="subtitle">Kann ich mit Karte bezahlen oder brauche ich Bargeld?</template>
        <template slot="content">
          <p>
            Während der Party bekommst du einen RFID Chip, mit dem du an der Bar bargeldlos bezahlen kannst.
            Bei der Abrechnung an der Kasse kannst du Bar, mit EC-Karte oder Kreditkarte (Visa, Mastercard) bezahlen.
          </p>
        </template>
      </expander>
    </div>
  </div>
</template>


<script>
  import Expander from '../components/Expander'

  export default {
    components: {
      Expander,
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep p.brunch {
    color: #F06292;
  }

  ::v-deep p.dance {
    color: #1976d2;
  }
</style>
